import React from "react";

function TelemetryCard({ title, value, subtitle }) {

return (

<div
style={{
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{title}</h3>

<h1
style={{
marginTop: "15px",
fontSize: "42px"
}}
>
{value}
</h1>

<p
style={{
color: "#94a3b8"
}}
>
{subtitle}
</p>

</div>

);

}

export default TelemetryCard;